import {View} from '@fantasmagames/slot/src/common/view/View';
import {Tween} from '@fantasmagames/core/src/tween/Tween';
import {Position, SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {Easing} from '@fantasmagames/core/src/tween/Easing';

export class BackgroundView extends View {
	public static readonly TRANSFER_TIME: number = 500;

	public static readonly VIEW_TRANSITION_TO_MAINGAME_COMPLETED: string = 'BackgroundView::__VIEW_TRANSITION_TO_MAINGAME_COMPLETED__';
	public static readonly VIEW_TRANSITION_TO_FREESPINS_COMPLETED: string = 'BackgroundView::__VIEW_TRANSITION_TO_FREESPINS_COMPLETED__';

	public static readonly BACKGROUND_CREATED: string = 'BackgroundView::BACKGROUND_CREATED';

	protected _mainGameBackground: PIXI.Sprite;
	protected _freeSpinsBackground: PIXI.Sprite;
	protected _window: PIXI.Sprite;

	protected _currentShakingTween: Tween;
	protected _currentScaleTween: Tween;

	protected _beforeShakingPosition: Position;

	public init(): void {
		super.init();

		this._window = new PIXI.Sprite();
		this.setupSprites();
		this.initBackgrounds();
	}

	public shakeBackground(power: number, repeats: number = NaN): void {
		this._beforeShakingPosition = {x: this.container.x, y: this.container.y};

		this.stopShaking();
		const duration: number = Math.ceil(50 * power);
		let totalRepeats: number = Math.ceil(3 * power);
		if (!isNaN(repeats)) {
			totalRepeats = repeats;
		}
		const basePos: SymbolPosition = {x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height};
		this.container.pivot.set(basePos.x, basePos.y);

		const strength: number = 25 * power;
		const getValues = (): SymbolPosition => {
			return {x: (Math.random() - 0.5) * strength + basePos.x, y: (Math.random() - 0.5) * strength + basePos.y};
		};

		this.container.position.set(getValues().x, getValues().y);

		// const endTween: Tween = new Tween(this.container).to({x: basePos.x, y: basePos.y}, duration);

		const shakeTween: Tween = new Tween(this.container)
			.to(getValues(), duration / totalRepeats)
			.repeat(totalRepeats)
			.yoyo(true)
			.easing(Easing.Linear.None)
			.onRepeat(() => {
				if (shakeTween.getRepeat() < totalRepeats) {
					shakeTween.to(getValues(), duration / (shakeTween.getRepeat() * shakeTween.getRepeat()));
				}
			})
			.onComplete(() => {
				shakeTween.to({x: basePos.x, y: basePos.y}, duration);
			})
			.start();

		this.updateManager.add(shakeTween);

		this._currentShakingTween = shakeTween;

		const scaleTween: Tween = new Tween(this.container.scale)
			.to({x: [Math.pow(1.03, power), 1], y: [Math.pow(1.03, power), 1]}, 250)
			.start();
		this.updateManager.add(scaleTween);

		this._currentScaleTween = scaleTween;
	}

	public stopShaking(): void {
		if (this._currentShakingTween) {
			this._currentShakingTween.stop();
			this.updateManager.remove(this._currentShakingTween);
			this._currentShakingTween = null;
		}

		if (this._currentScaleTween) {
			this._currentScaleTween.stop();
			this.updateManager.remove(this._currentScaleTween);
			this._currentScaleTween = null;
		}

		this.container.scale.set(1.0);
		const basePos: SymbolPosition = {x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height};
		this.container.pivot.set(basePos.x, basePos.y);
		this.container.position.set(basePos.x, basePos.y);
	}

	public showMainGameBackground(): void {
		this._mainGameBackground.alpha = 1.0;
		if (this._freeSpinsBackground) {
			this._freeSpinsBackground.alpha = 0.0;
		}
	}

	public showFreeSpinsBackground(): void {
		this._mainGameBackground.alpha = 0.0;
		if (this._freeSpinsBackground) {
			this._freeSpinsBackground.alpha = 1.0;
		}
	}

	public playTransitionToMainGame(): void {
		const disappearTween: Tween = new Tween(this._freeSpinsBackground)
			.to({alpha: 0.0}, BackgroundView.TRANSFER_TIME)
			.onComplete(this.onTransitionToMainGameCompleted.bind(this))
			.start();

		const appearTween: Tween = new Tween(this._mainGameBackground).to({alpha: 1.0}, BackgroundView.TRANSFER_TIME).start();

		this.updateManager.add(disappearTween);
		this.updateManager.add(appearTween);
	}

	public playTransitionToFreeSpins(): void {
		const disappearTween: Tween = new Tween(this._mainGameBackground)
			.to({alpha: 0.0}, BackgroundView.TRANSFER_TIME)
			.onComplete(this.onTransitionToFreeSpinsCompleted.bind(this))
			.start();

		const appearTween: Tween = new Tween(this._freeSpinsBackground).to({alpha: 1.0}, BackgroundView.TRANSFER_TIME).start();

		this.updateManager.add(disappearTween);
		this.updateManager.add(appearTween);
	}

	protected onTransitionToFreeSpinsCompleted(): void {
		this.emit(BackgroundView.VIEW_TRANSITION_TO_FREESPINS_COMPLETED);
	}

	protected onTransitionToMainGameCompleted(): void {
		this.emit(BackgroundView.VIEW_TRANSITION_TO_MAINGAME_COMPLETED);
	}

	protected setupSprites(): void {
		this._mainGameBackground = new PIXI.Sprite(this.resources.getTexture('BACKGROUND.png'));
	}

	protected initBackgrounds(): void {
		this.container.addChild(this._window);
		this._window.addChild(this._mainGameBackground);
		if (this._freeSpinsBackground) {
			this._window.addChild(this._freeSpinsBackground);
		}

		this.showMainGameBackground();

		this.emit(BackgroundView.BACKGROUND_CREATED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/background/BackgroundView.ts